
const theme = {
  SHOPTITLE: "MAGS"
}

export default theme



// WEBPACK FOOTER //
// ./src/theme.js